<div class="countdown-timer" [ngClass]="hour ? '' : 'w-unset'">
  <div class="hours" *ngIf="hour !== 0"><span>{{hour | extraZero}}</span></div>
  <div class="minutes"><span>{{minute | extraZero}}</span></div>
  <div class="seconds"><span>{{second | extraZero}}</span></div>
</div>
